import { PhoneNumberUtil } from 'google-libphonenumber';
import { useMemo } from 'react';

const phoneUtil = PhoneNumberUtil.getInstance();

const useIsPhoneValid = (phone: string) =>
  useMemo(() => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch {
      return false;
    }
  }, [phone]);

export { useIsPhoneValid };
